import {
  updateRangeFacet,
  setRangeValues,
  undoRangeValues,
  clearRangeFacet
} from "../actionCreators";
import { isLargeMediumViewPort } from "../viewportHelper";
import applyFacets from "../facets/apply";
import {
  analyticsRefinementsSelect,
  analyticsAddPendingRefinementSelect
} from "../../analytics/actions";

export { updateRangeFacet, clearRangeFacet };

export const setNextPriceRangeToCurrent = setRangeValues;

export const undoPriceRange = undoRangeValues;

export function changeRangeFacet(facetId, value) {
  return dispatch => {
    dispatch(updateRangeFacet(facetId, value));
  };
}

export function applyRangeFacet(facet) {
  return (dispatch, getState) => {
    const state = getState();
    if (isLargeMediumViewPort(state)) {
      dispatch(applyFacets());
      dispatch(analyticsAddPendingRefinementSelect({ facet }));
    } else {
      dispatch(analyticsRefinementsSelect({ facet }));
    }
  };
}
